// extracted by mini-css-extract-plugin
export var error = "styles-module--error--06dbf";
export var iframe = "styles-module--iframe--b9cc0";
export var pending = "styles-module--pending--46281";
export var report = "styles-module--report--ce3eb";
export var shared = "styles-module--shared--63b16";
export var spinner = "styles-module--spinner--b0bd1";